// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UP3u","footer":"styles_footer__3LjXy"};